const prefix = 'group-details';

const SET_BASIC_INFO = `${prefix}/SET_BASIC_INFO`;

const SET_USERS = `${prefix}/SET_USERS`;

const SET_POLICIES = `${prefix}/SET_POLICIES`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_BASIC_INFO, SET_USERS, SET_POLICIES, RESET, SET_LOADING };
